module.exports = __webpack_public_path__ + "static/media/BRS-72.ded79f21.png";